exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".header__img[data-v-4cd3cc96]{max-height:260px;min-height:250px}\n", ""]);

